__webpack_require__.p = "/medi-decentra/";